import { Component } from 'react';

import { setToken, clearToken } from './../utils/tokenStorage';

class PageAuth extends Component {
  componentDidMount() {debugger
    clearToken();
    const { match, history } = this.props;
    const { token } = match.params;
    setToken(token);
    // history.replace('/welcome');
    history.replace('/applicant-info');
  }

  render() {
    return null;
  }
}

export default PageAuth;



// WEBPACK FOOTER //
// ./src/components/PageAuth.js